export default __webpack_public_path__ + "static/media/index.a3e1473d.less";